import { createContext } from 'react'

export interface User {
  id: number
  username: string | null
  email: string | null
  discordId?: string | null
  guildedId?: string | null
  role?: string
  hasPassword?: boolean
  economyStats?: {
    coinsCount: number
    xpCount: number
    dailyStreak: number
    messagesCount: number
  } | null
}

interface AuthContextType {
  user: User | null
  isAuthenticated: boolean
  login: (user: User) => void
  logout: () => Promise<void>
  loading: boolean
  refetchUser: () => Promise<void>
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
